import React from "react";
import moment from "moment";
import pick from "lodash/pick";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { Flex, Box } from "grid-styled";
import { reduxForm, Field } from "redux-form";
import { P } from "./Text";
import { InputContainer, Select, DatePicker } from "./forms";
import { Panel, PanelHeader, PanelBody } from "./Panel";
import Button from "./Button";
import { FRANCHISE_CERTIFICATION_STATUSES } from "../constants";

const CERTIFICATION_STATUS_OPTIONS = FRANCHISE_CERTIFICATION_STATUSES.map(
  status => ({
    value: status,
    label: status
  })
);

const FranchiseInfoForm = reduxForm({
  form: "franchiseInfoEdit"
})(({ handleSubmit, onCancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="name"
          labelText="Location Name"
          component={InputContainer}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="corporateName"
          labelText="Corporate Name"
          component={InputContainer}
        />
      </Box>
      <Box pb={2}>
        <Field name="phone" labelText="Phone" component={InputContainer} />
      </Box>
      <Box pb={2}>
        <Field name="email" labelText="Email" component={InputContainer} />
      </Box>
      <Box pb={2}>
        <Field
          name="assignedInHouseTty"
          labelText="Assigned In-House TTY"
          component={InputContainer}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="certificationStatus"
          labelText="Certification Status"
          component={InputContainer}
          fieldComponent={Select}
          options={CERTIFICATION_STATUS_OPTIONS}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="franchiseAgreementEffectiveOn"
          labelText="Franchise Agreement Effective On"
          component={InputContainer}
          fieldComponent={DatePicker}
          utc
        />
      </Box>
      <Box pb={2}>
        <Field
          name="franchiseAgreementExpiresOn"
          labelText="Franchise Agreement Expires On"
          component={InputContainer}
          fieldComponent={DatePicker}
          utc
        />
      </Box>
      <Box pb={2}>
        <Field
          name="chatmeterId"
          labelText="Chatmeter ID"
          component={InputContainer}
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class FranchiseInfoCard extends React.Component {
  static propTypes = {
    franchise: PropTypes.object,
    onSave: PropTypes.func.isRequired
  };

  state = {
    loading: false,
    error: null,
    transmittals: [],
    editing: false
  };

  save = values => {
    return this.props
      .onSave({
        ...values,
        franchiseAgreementEffectiveOn: moment(
          values.franchiseAgreementEffectiveOn
        ).format("YYYY-MM-DD"),
        franchiseAgreementExpiresOn: moment(
          values.franchiseAgreementExpiresOn
        ).format("YYYY-MM-DD")
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderInfo() {
    const { franchise } = this.props;
    return (
      <div>
        <P>
          <b>Location Name</b>
          <br />
          {franchise.name}
        </P>
        <P>
          <b>Corporate Name</b>
          <br />
          {franchise.corporateName}
        </P>
        <P>
          <b>Phone</b>
          <br />
          {franchise.phone}
        </P>
        <P>
          <b>Email</b>
          <br />
          {franchise.email}
        </P>
        <P>
          <b>Assigned In-House TTY</b>
          <br />
          {franchise.assignedInHouseTty}
        </P>
        <P>
          <b>Certification Status</b>
          <br />
          {franchise.certificationStatus}
        </P>
        <P>
          <b>Franchise Agreement Effective On</b>
          <br />
          <Moment format="MMM D, YYYY" utc>
            {franchise.franchiseAgreementEffectiveOn}
          </Moment>
        </P>
        <P>
          <b>Franchise Agreement Expires On</b>
          <br />
          <Moment format="MMM D, YYYY" utc>
            {franchise.franchiseAgreementExpiresOn}
          </Moment>
        </P>
        <P>
          <b>Chatmeter ID</b>
          <br />
          {franchise.chatmeterId}
        </P>
      </div>
    );
  }

  renderForm() {
    const { franchise } = this.props;
    let initialValues = pick(
      franchise,
      "name",
      "corporateName",
      "phone",
      "email",
      "assignedInHouseTty",
      "certificationStatus",
      "chatmeterId",
      "excludeFromReporting"
    );

    initialValues.franchiseAgreementEffectiveOn =
      franchise.franchiseAgreementEffectiveOn || moment();
    initialValues.franchiseAgreementExpiresOn =
      franchise.franchiseAgreementExpiresOn || moment();

    return (
      <FranchiseInfoForm
        initialValues={initialValues}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { contact, onSave, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>Franchise Details</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>{editing ? this.renderForm() : this.renderInfo()}</PanelBody>
      </Panel>
    );
  }
}

export default FranchiseInfoCard;



// WEBPACK FOOTER //
// ./src/components/FranchiseInfoCard.js